import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {},
	finalize() {
		//animation / gsap
		//header
		let $singleHeaderWrap = $('.single-header-wrap')[0]
		if ($singleHeaderWrap) {
			gsap.fromTo(
				'.single-header-wrap',
				{
					x: 50,
					opacity: 0,
				},
				{
					scrollTrigger: '.single-header-wrap',
					delay: 0.5,
					duration: 0.25,
					x: 0,
					opacity: 1,
				}
			)
		}

		//body
		let $singleImage = $('.single-image')[0]
		if ($singleImage) {
			gsap.fromTo(
				'.single-image',
				{
					x: -65,
					opacity: 0,
				},
				{
					scrollTrigger: '.single-image',
					delay: 0.5,
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
		}
		let $time = $('.single-content-wrap > time')[0]
		if ($time) {
			gsap.fromTo(
				'.single-content-wrap > time',
				{
					x: 65,
					opacity: 0,
				},
				{
					scrollTrigger: '.single-content-wrap > time',
					delay: 0.5,
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
		}
		let $header = $('.single-header')[0]
		if ($header) {
			gsap.fromTo(
				'.single-header',
				{
					x: -65,
					opacity: 0,
				},
				{
					scrollTrigger: '.single-header',
					delay: 0.5,
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
		}
		let $copy = $(
			'.single-content-wrap p, .single-content-wrap img, .single-content-wrap li, .single-content-wrap h2, .single-content-wrap h3, .single-content-wrap h4'
		)
		if ($copy.length) {
			document
				.querySelectorAll(
					'.single-content-wrap p, .single-content-wrap img, .single-content-wrap li, .single-content-wrap h2, .single-content-wrap h3, .single-content-wrap h4'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ y: 15, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							y: 0,
							opacity: 1,
						}
					)
				})
		}
		let $share = $('.share-wrap')[0]
		if ($share) {
			gsap.fromTo(
				'.share-wrap',
				{
					y: 15,
					opacity: 0,
				},
				{
					scrollTrigger: '.share-wrap',
					delay: 0.5,
					duration: 0.5,
					y: 0,
					opacity: 1,
				}
			)
		}
		let $pagination = $('.single-post-btn-wrap')[0]
		if ($pagination) {
			gsap.fromTo(
				'.single-post-btn-wrap',
				{
					y: 15,
					opacity: 0,
				},
				{
					scrollTrigger: '.single-post-btn-wrap',
					delay: 0.5,
					duration: 0.5,
					y: 0,
					opacity: 1,
				}
			)
		}
	},
}
